
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"551","height":"359"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(0 1)"}},[_c('path',{attrs:{"stroke":"#38393A","d":"M220.7 62.908h295.425v60.784H220.7z"}}),_c('path',{attrs:{"fill":"#400F3F","fill-rule":"nonzero","d":"M199.785 74.673H495.21v60.784H199.785z"}}),_c('circle',{attrs:{"cx":"13.033","cy":"12.091","r":"4.575","fill":"#400F3F","fill-rule":"nonzero"}}),_c('circle',{attrs:{"cx":"28.72","cy":"12.091","r":"4.575","fill":"#400F3F","fill-rule":"nonzero"}}),_c('circle',{attrs:{"cx":"44.406","cy":"12.091","r":"4.575","fill":"#400F3F","fill-rule":"nonzero"}}),_c('path',{attrs:{"stroke":"#38393A","d":"M.615.327h549.02V357.19H.615zm0 19.827h549.02"}}),_c('circle',{attrs:{"cx":"14.341","cy":"10.131","r":"4.575","stroke":"#38393A"}}),_c('circle',{attrs:{"cx":"30.027","cy":"10.131","r":"4.575","stroke":"#38393A"}}),_c('circle',{attrs:{"cx":"45.713","cy":"10.131","r":"4.575","stroke":"#38393A"}}),_c('path',{attrs:{"stroke":"#38393A","d":"M172.985 20.154v337.543"}}),_c('path',{attrs:{"fill":"#F1F2F3","fill-rule":"nonzero","d":"M234.753 186.111h96.078v13.072h-96.078zm150.98 0h96.078v13.072h-96.078z"}}),_c('path',{attrs:{"stroke":"#38393A","d":"M239.981 179.575h96.078v13.072h-96.078z"}}),_c('path',{attrs:{"fill":"#F1F2F3","fill-rule":"nonzero","d":"M234.753 287.418h96.078v13.072h-96.078z"}}),_c('path',{attrs:{"stroke":"#38393A","d":"M239.981 280.882h96.078v13.072h-96.078z"}}),_c('path',{attrs:{"fill":"#F1F2F3","fill-rule":"nonzero","d":"M235.08 235.458h247.059v13.072H235.08z"}}),_c('path',{attrs:{"stroke":"#38393A","d":"M240.308 230.229h247.059v13.072H240.308zm150.654-50.654h96.078v13.072h-96.078z"}})])])
          )
        }
      }
    